import { useEffect } from 'react';

let locks = 0;
let previous = '';

/** Stops the page behind a modal (Dialog, Sheet) from scrolling while `active`. Nested locks are counted. */
export function useScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return undefined;
    if (locks === 0) {
      previous = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    locks += 1;
    return () => {
      locks -= 1;
      if (locks === 0) document.body.style.overflow = previous;
    };
  }, [active]);
}
